export const ROWS_IN_DATA_TABLES = 25;
export const ROWS_PER_PAGE_IN_DATA_TABLES = [25, 50, 100];
